// import attributes from "./attributes";
import Edit from "./Edit";

const { registerBlockType } = wp.blocks;
import metadata from "./../../../blocks/pdfposter/block.json";
registerBlockType(metadata, {
  edit: Edit,
  save: () => {
    return null;
  },
});
